import { render, staticRenderFns } from "./EventLogView.vue?vue&type=template&id=fd5fd85a&scoped=true&"
import script from "./EventLogView.vue?vue&type=script&lang=ts&"
export * from "./EventLogView.vue?vue&type=script&lang=ts&"
import style0 from "./EventLogView.vue?vue&type=style&index=0&id=fd5fd85a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5fd85a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
